module.exports = __webpack_public_path__ + "img/2025-05-09d_2.e39cff70.jpg";